<template>


	<div :class="orderBox">

		<div class="orderRow">

			<span class="orderName">{{info.orderName}}</span>
			<span class="amount">{{info.settlementPrice}}</span>
		</div>

		<div class="orderRow">
			<span class="orderType">{{(info.orderStatus=='assigned')?'派单模式':'抢单模式'}} | 发布于{{parseDay(info.releaseTime)}}</span>
			<div class="orderButton" @click="acceptOrder(info)">立即接单</div>

		</div>
		<div class="orderRow">
			<div class="dotted"></div>
		</div>
		<div class="orderRow">
			<p class="orderDescribe">{{info.orderDescribe}}</p>
		</div>
			<el-dialog :visible.sync="dialogVisible" width="18vw">
					
					<login></login>
					
				</el-dialog>
	</div>


</template>

<script>
	import {
		parseDay
	} from '../../utils/index.js'
	import {
		add
	} from '../../api/orderAccept.js'
	import {
		mapGetters
	} from 'vuex'
	import checkPermission from '../../utils/permission.js'
	import login from '../login/login.vue'
	export default {
		components:{
			login
		},
		props: {
			info: Object,
			imgSort: Number
		},
		computed: {

			...mapGetters(['Login']),
			
			orderBox() {

				return "orderBox bg_img_" + this.imgSort

			}

		},
		data(){
			return {
				dialogVisible:false
			}
		},
		methods: {
			parseDay,
			acceptOrder(item) {
				console.log('[item]', item);
				//首先验证登录
				if (this.Login.username) {

					if (item.releaseType == 'public') {
						if (checkPermission(["YUMIENTERPRISEUSER_SELECT_SELF"])) {
							this.$alert('您的身份是企业用户，无法承接', '提示', {
								confirmButtonText: '确定'
							})
							return false
						}
						this.sendAcceptOrderMsg(item)
					} else {
						this.$alert('该订单已被指派，无法承接', '提示', {
							confirmButtonText: '确定'
						})
					}


				} else {
					this.dialogVisible = true
				}
			},
			sendAcceptOrderMsg(item) {

				this.$confirm('是否确认承接该订单?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let accept = {
						//在后台获取
						supplierId: null,
						orderId: item.id,
						enterpriseId: item.enterprise.id,
						status: 'send'
					}

					add(accept).then(res => {
						this.$message({
							type: 'success',
							message: '承接成功!'
						});
					})


				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
			}
		}


	}
</script>

<style>
	.orderBox {
		width: 22.15vw;
		height: 10.65vw;
		padding-top: 1rem;

		box-shadow: 0vw 0vw 1.04vw 0vw rgba(110, 110, 110, 0.14);
		background-color: #FFFFFF;
		padding-left: 1.6vw;
		padding-right: 1.4vw;
		border-radius: 0.5vw;
		padding-bottom: 1.67vw;

		background-position: right bottom;

		background-repeat: no-repeat;
	}

	.bg_img_0 {
		background-image: url(../../assets/01.png);
		background-size: 7.4vw 6.25vw;
	}

	.bg_img_1 {
		background-image: url(../../assets/02.png);
		background-size: 7.7vw 5.7vw;
	}

	.bg_img_2 {
		background-image: url(../../assets/03.png);
		background-size: 6.4vw 6.3vw;
	}

	.bg_img_3 {
		background-image: url(../../assets/04.png);
		background-size: 7.9vw 5.7vw;
	}

	.bg_img_4 {
		background-image: url(../../assets/05.png);
		background-size: 6.6vw 6.14vw;
	}

	.orderCenter {
		display: flex;
		justify-content: center;
		padding-left: 0.75rem !important;
	}

	.orderRow {
		width: 100%;
		display: flex;
		justify-content: space-between;

	}

	.orderName {

		font-family: SourceHanSansCN-Regular;
		font-size: 1.25rem;
		font-weight: normal;
		font-stretch: normal;
		line-height: 2.25rem;
		letter-spacing: 0.5px;
		color: #000000;
	}

	.amount {
		font-size: 1.25rem;
		font-weight: normal;
		font-stretch: normal;
		line-height: 2.25rem;
		letter-spacing: 0.5px;
		color: #f85900;
	}

	.orderButton {

		width: 5.68vw;
		height: 1.88vw;
		background-color: #f96500;
		border-radius: 1vw;
		font-size: 1vw;
		line-height: 1.88vw;
		text-align: center;
		color: #FFFFFF;
	}

	/* border-style:dotted; */

	.dotted {
		margin-top: 1vw;
		width: 100%;
		height: 0.0625rem;
		/* background-image: url(http://introduce.yjyumi.com/img/8980.jpg); */

	}

	.orderDescribe {

		font-family: SourceHanSansCN-Regular;
		font-size: 0.6vw;
		font-weight: normal;
		font-stretch: normal;
		line-height: 1.15vw;
		letter-spacing: 0.025rem;
		color: #666666;

		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 5;
		-webkit-box-orient: vertical;
		overflow: hidden;
	}
</style>
